/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { SubPage, Group, Tip, Grid, GridSet, GridItem, Copy, Title, CTAs, Button, SingleSelectDropDown, LoadState, Loader } from '@insticator/insticator-ui'; // iui-material
import AdsTxtIndicator from 'pages/dashboard/account/adstxt/adstxtindicator/adstxtindicator_container';
// utils
import { downloadTxtFile, ValueHighlighter } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/adstxt/adstxt_styles';



/* ========== ~~~~~~~~~~ ACCOUNT ADsTXT ~~~~~~~~~~ ========== */
class Adstxt extends Component {
    constructor(props){
        super(props);
        this.state={ selectedSite: null } ;
    }

    componentDidMount(){
        if(Object.keys(this.props.sites).length){
            this.fetchFirstSitesAdsTxt()
        }
    }

    componentDidUpdate(prevProps){
        if(Object.keys(prevProps.sites).length !== Object.keys(this.props.sites).length){
            this.fetchFirstSitesAdsTxt()
        }
    }

    fetchFirstSitesAdsTxt = () => {
        let firstSite = {name: this.props.sites[Object.keys(this.props.sites)[0]], value: Object.keys(this.props.sites)[0]};
        this.props.getAdsTxt(this.props.accountUUID, firstSite);
    };

    handleIndicator = () => this.props.containsAdsTxt !== null ? <AdsTxtIndicator containsAdsTxt={this.props.containsAdsTxt} installed={this.props.adsTxtComplete}/> : null;

    handleSiteInDropDown = () => {
        let sites = [];
        Object.keys(this.props.sites).forEach( (item) => {
            sites.push({value: item, name: this.props.sites[item]})
        });

        return sites
    };

    handleAdsTxtFetch = (site) =>{
        this.props.getAdsTxt(this.props.accountUUID, site);
        this.setState({selectedSite: site})
    };

    handleAdsTxtVerify = () => {
        this.props.verifyAdsTxt(this.props.selectedSite.value)
    };
    formatArrayToStringFile = (arr) => {
        let str = ``;
        arr.map(val => str = str + `${val}\n`);
        return str;
    };
    handleAdsTxtDownload = () => {
        if(this.props.adsTxtValues)downloadTxtFile('ads.txt', this.formatArrayToStringFile(this.props.adsTxtValues))
    };
    render() {
        if(this.props.fetchingSites){
            return <LoadState/>
        }
        return (
            <SubPage name={`adstxt`} klass={this.props.classes.adstxt}>
                <Copy name={`page-copy`}>
                    <Title variant={`withtip`}>
                        <h2>Ads.txt Implementation</h2>
                        <Tip space={`left`} content={<p>An ads.txt file is a simple text file (not an Embed code) that is uploaded into your domain’s root directory. In other words, it is implemented the same way a robots.txt file on your root domain would be implemented.</p>}/>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <Grid>
                        <GridSet name={`sites-indicator`}>
                            <GridItem name={'sites'}>
                                <SingleSelectDropDown onSelect={this.handleAdsTxtFetch} disabled={this.props.fetchingSites || !this.props.sitesReceived} selected={this.props.selectedSite} name={`all sites`} items={this.handleSiteInDropDown()}/>
                            </GridItem>
                            <GridItem>
                                {this.handleIndicator()}
                            </GridItem>
                        </GridSet>
                        <GridSet>
                            <GridItem name={`adstxt-values`}>
                                {this.props.adsTxtFetching ? <Loader/> :
                                    <ValueHighlighter
                                    values={this.props.adsTxtValues}
                                    valuesToHighlight={this.props.missingElements}
                                    minHeight={'236px'}
                                    direction={'column'}
                                    showHighlightedFirst={true}
                                    scrollable={true} />}
                            </GridItem>
                        </GridSet>
                        <GridSet>
                            <GridItem name={`adstxt-ctas`}>
                                <CTAs name={`adstxt-ctas`}>
                                    <Button variant={this.props.selectedSite ? `primary` : `disabled`} disabled={this.props.adsTxtFetching} type={'action'} text={`Verify Installation`} action={this.handleAdsTxtVerify}/>
                                    <Button variant={this.props.selectedSite ? `primary` : `disabled`} disabled={this.props.adsTxtFetching} type={'action'} text={`Download ads.txt`} action={this.handleAdsTxtDownload}/>
                                </CTAs>
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Group>
            </SubPage>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Adstxt);
